export enum ReorderSortType {
  PURCHASE_PREDICTION = 0,
  MOST_PURCHASED = 1,
  RECENTLY_PURCHASED = 2,
  LOWEST_PRICE = 3,
  HIGHEST_PRICE = 4,
}

export function getReorderSortLabel(sort: ReorderSortType): string | null {
  if (sort) {
    switch (sort) {
      case ReorderSortType.MOST_PURCHASED:
        return "Most Frequently Purchased";
      case ReorderSortType.RECENTLY_PURCHASED:
        return "Most Recently Purchased";
      case ReorderSortType.LOWEST_PRICE:
        return "Lowest Price";
      case ReorderSortType.HIGHEST_PRICE:
        return "Highest Price";
      default:
        return "Time to Purchase Prediction";
    }
  }
  return null;
}

export function getReorderSortCamelCaseLabel(sort: ReorderSortType): string {
  switch (sort) {
    case ReorderSortType.MOST_PURCHASED:
      return "mostFrequentlyPurchased";
    case ReorderSortType.RECENTLY_PURCHASED:
      return "mostRecentlyPurchased";
    case ReorderSortType.LOWEST_PRICE:
      return "lowestPrice";
    case ReorderSortType.HIGHEST_PRICE:
      return "highestPrice";
    default:
      return "timeToPurchasePrediction";
  }
}

export function getReorderSortFromCamelCaseLabel(sortString: string | undefined): ReorderSortType {
  if (typeof sortString === "undefined" || sortString === null) return ReorderSortType.PURCHASE_PREDICTION;
  switch (sortString) {
    case "mostFrequentlyPurchased":
      return ReorderSortType.MOST_PURCHASED;
    case "mostRecentlyPurchased":
      return ReorderSortType.RECENTLY_PURCHASED;
    case "lowestPrice":
      return ReorderSortType.LOWEST_PRICE;
    case "highestPrice":
      return ReorderSortType.HIGHEST_PRICE;
    default:
      return ReorderSortType.PURCHASE_PREDICTION;
  }
}
